import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@material-ui/core';
import CalApiContext from './CalApiContext';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}),
);

export default function Navigation() {
  const { calApi, activeDate, setActiveDate } = React.useContext(CalApiContext)
  const classes = useStyles();
 
  const moveCalForward = () => {
    calApi.current.getApi().next()
    setActiveDate(calApi.current.getApi().view.title)
  }

  const moveCalBack = () => {
    calApi.current.getApi().prev()
    setActiveDate(calApi.current.getApi().view.title)
  }

  const moveCalToady = () => {
    calApi.current.getApi().today()
    setActiveDate(calApi.current.getApi().view.title)
  }

  return (
    <div className={classes.root}>
      <AppBar position='static'>
        <Toolbar>
          {/* <IconButton edge="start" className={classes.menuButton} color='inherit' aria-label='menu'>
          <MenuIcon />
          </IconButton> */}
          <Typography variant='h6' className={classes.title}>
            <Link color='inherit' underline='none' component={RouterLink} to='/'>Event Calendar</Link>
          </Typography>
          <Typography className={classes.title}>
            {activeDate}
          </Typography>
          <Typography>
            <Button edge="start" className={classes.menuButton} color='inherit' aria-label='menu' onClick={moveCalToady}>Today</Button>
            <IconButton edge="start" color='inherit' aria-label='menu' onClick={moveCalBack}>
              <ArrowBackIcon/>
            </IconButton>
            <IconButton edge="start" color='inherit' aria-label='menu' onClick={moveCalForward}>
              <ArrowForwardIcon/>
            </IconButton>
            {/* <Button className={classes.menuButton} color='inherit'><Link color='inherit' underline='none' component={RouterLink} to='/signin'>Sign In</Link></Button> */}
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
}